import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnUser } from './../user/user';
import { SnWidget } from './widget';

export class SnOperationalView extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public organization: string;

  @Expose()
  @Type(() => SnUser)
  public user: SnUser;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  public isPersonal: boolean;

  @Expose()
  public isPublic: boolean;

  @Expose()
  public widgets: SnWidget[];

  @Expose()
  public team: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
